
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { getCheckList, addEvent } from '@/api/orderPolling';

@Component({
  name: 'selectPolling',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })dialogAddEventVisible!:Boolean;
  @Prop({
    type: Object,
    default: () => {}
  })event!:any;

  private formSearchAddEvent:any = {
    name: '',
    checkdata: []
  }
  private datalistEvent:any = []

  created() {
    this.getCheckList();
  }

  private getCheckList() {
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    parmars.page = 1;
    parmars.size = 1000;
    getCheckList(parmars).then(res => {
      if (res.data) {
        this.datalistEvent = res.data.list;
      } else {
        this.datalistEvent = [];
      }
    }).catch(err => {
      let msg = err;
    });
  }

  private selectionChange(val: any) {
    this.formSearchAddEvent.checkdata = val;
  }

  private addEventFinsh() {
    if (this.formSearchAddEvent.name === '') {
      this.showErrorMsg('由1-30个数字、字母、汉字组成的自定义事件名称');
      return;
    }
    let checkids = '';
    this.formSearchAddEvent.checkdata.forEach((element:any) => {
      checkids = checkids + element.id + ',';
    });
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.user_name = UserModule.getUserName;
    parmars.company_name = UserModule.getCompanyName;
    parmars.company_id = UserModule.getCompanyId;
    parmars.name = this.formSearchAddEvent.name;
    parmars.check_list = checkids.substring(0, checkids.length - 1);
    if (this.event && this.event.id) {
      parmars.pid = this.event.id;
    }
    addEvent(parmars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.$emit('selectEventAdd', res.data);
      this.close();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private close() {
    this.$emit('close', false);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}

